import { render, staticRenderFns } from "./PaymentStripeCheckoutResult.vue?vue&type=template&id=01fafbdc&scoped=true"
import script from "./PaymentStripeCheckoutResult.vue?vue&type=script&lang=js"
export * from "./PaymentStripeCheckoutResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fafbdc",
  null
  
)

export default component.exports